<template>
    <div class="review-container" style="margin-top: 10px;margin-left: 30px;">
        <el-tabs v-model="activeTab">
            <el-tab-pane label="数据资产登记审核" name="review">
                <!-- 第一部分：主体信息 -->
                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>企业信息</span>
                    </div>
                    <el-descriptions :column="2" border>
                        <el-descriptions-item label="主体名称">{{ formData.companyName }}</el-descriptions-item>
                        <el-descriptions-item label="统一社会信用码">{{ formData.socialCreditCode }}</el-descriptions-item>

                    </el-descriptions>
                </el-card>

                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>联系人信息</span>
                    </div>
                    <el-descriptions :column="2" border>

                        <el-descriptions-item label="联系人">{{ formData.contactsName }}</el-descriptions-item>
                        <el-descriptions-item label="手机号">{{ formData.contactsPhone }}</el-descriptions-item>
                    </el-descriptions>
                </el-card>


                <!-- 第二部分：基本信息 -->
                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>基本信息</span>
                    </div>
                    <el-descriptions :column="1" border>
                        <el-descriptions-item label="数据资产名称" class="custom-label">{{ formData.assetName
                            }}</el-descriptions-item>
                        <el-descriptions-item label="数据来源">{{ formData.dataSource }}</el-descriptions-item>
                        <el-descriptions-item label="所属行业">{{ formData.industry }}</el-descriptions-item>
                        <el-descriptions-item label="数据类型">{{ formData.dataType }}</el-descriptions-item>
                        <el-descriptions-item label="数据覆盖地域">{{ formData.region }}</el-descriptions-item>
                        <el-descriptions-item label="应用场景描述">{{ formData.scenario }}</el-descriptions-item>
                        <el-descriptions-item label="数据资产简介">{{ formData.description }}</el-descriptions-item>
                    </el-descriptions>
                </el-card>

                <!-- 第三部分：数据属性 -->
                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>数据属性</span>
                    </div>
                    <el-descriptions :column="1" border>
                        <el-descriptions-item label="数据结构">{{ formData.dataScaleType }}</el-descriptions-item>
                        <el-descriptions-item
                            v-if="formData.dataScaleType === '复合型数据' || formData.dataScaleType === '结构化数据'"
                            label="存储空间">{{
                                formData.storageUnit }}</el-descriptions-item>
                        <el-descriptions-item
                            v-if="formData.dataScaleType === '复合型数据' || formData.dataScaleType === '结构化数据'"
                            label="数据规模">{{
                                formData.contactName }}</el-descriptions-item>
                        <el-descriptions-item
                            v-if="formData.dataScaleType === '复合型数据' || formData.dataScaleType === '非结构化数据'"
                            label="文件数量">
                            {{ formData.fileCount }}
                        </el-descriptions-item>
                        <el-descriptions-item label="数据期间">{{ formData.creator }}</el-descriptions-item>
                        <el-descriptions-item label="更新周期">{{ formData.updateCycle }}</el-descriptions-item>
                    </el-descriptions>
                </el-card>

                <!-- 第四部分：产权信息 -->
                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>产权信息</span>
                    </div>
                    <el-descriptions :column="1" border>
                        <el-descriptions-item label="权利类型">{{ formData.rightsType }}</el-descriptions-item>
                        <el-descriptions-item label="产权期限">{{ formData.updater }}</el-descriptions-item>
                        <el-descriptions-item label="使用限制">{{ formData.usageLimit }}</el-descriptions-item>
                    </el-descriptions>
                </el-card>

                <!-- 第五部分：证明材料 -->
                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>证明材料</span>
                    </div>
                    <el-descriptions :column="1" border>
                        <el-descriptions-item label="数据资产查验报告">
                            <div v-if="formData.reportFile && formData.reportFile.length > 0">
                                <div v-for="(file, index) in formData.reportFile" :key="index" class="file-item">
                                    <span>{{ file }}</span>
                                    <el-button v-if="isPreviewable(file)" type="text" size="mini"
                                        @click="previewFile(file)" style="margin-left: 8px;">
                                        预览
                                    </el-button>
                                    <el-button type="text" size="mini" @click="downloadFile(file)"
                                        style="margin-left: 8px;">
                                        下载
                                    </el-button>
                                </div>
                            </div>
                            <span v-else>无</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="数据资产查验详情表">
                            <div v-if="formData.verificationFile && formData.verificationFile.length > 0">
                                <div v-for="(file, index) in formData.verificationFile" :key="index" class="file-item">
                                    <span>{{ file }}</span>
                                    <el-button v-if="isPreviewable(file)" type="text" size="mini"
                                        @click="previewFile(file)" style="margin-left: 8px;">
                                        预览
                                    </el-button>
                                    <el-button type="text" size="mini" @click="downloadFile(file)"
                                        style="margin-left: 8px;">
                                        下载
                                    </el-button>
                                </div>
                            </div>
                            <span v-else>无</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="数据资产登记承诺书">
                            <div v-if="formData.commitmentFile && formData.commitmentFile.length > 0">
                                <div v-for="(file, index) in formData.commitmentFile" :key="index" class="file-item">
                                    <span>{{ file }}</span>
                                    <el-button v-if="isPreviewable(file)" type="text" size="mini"
                                        @click="previewFile(file)" style="margin-left: 8px;">
                                        预览
                                    </el-button>
                                    <el-button type="text" size="mini" @click="downloadFile(file)"
                                        style="margin-left: 8px;">
                                        下载
                                    </el-button>
                                </div>
                            </div>
                            <span v-else>无</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="其他材料">
                            <div v-if="formData.otherFile && formData.otherFile.length > 0">
                                <div v-for="(file, index) in formData.otherFile" :key="index" class="file-item">
                                    <span>{{ file }}</span>
                                    <el-button v-if="isPreviewable(file)" type="text" size="mini"
                                        @click="previewFile(file)" style="margin-left: 8px;">
                                        预览
                                    </el-button>
                                    <el-button type="text" size="mini" @click="downloadFile(file)"
                                        style="margin-left: 8px;">
                                        下载
                                    </el-button>
                                </div>
                            </div>
                            <span v-else>无</span>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-card>

                <!-- 审核标准部分 -->
                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span class="required-field">审核标准</span>
                    </div>
                    <div class="review-standard-item">
                        <span>是否完整填写数据资产基本信息</span>
                        <el-radio-group v-model="auditCriteria1">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="review-standard-item">
                        <span>是否完整填写数据属性信息</span>
                        <el-radio-group v-model="auditCriteria2">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="review-standard-item">
                        <span>是否完整填写产权信息</span>
                        <el-radio-group v-model="auditCriteria3">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="review-standard-item">
                        <span>整体描述内容是否与本身相符</span>
                        <el-radio-group v-model="auditCriteria4">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="review-standard-item">
                        <span>相关证明材料是否齐全</span>
                        <el-radio-group v-model="auditCriteria5">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                </el-card>

                <!-- AI审核部分 -->
                <!-- <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>AI审核</span>
                    </div>
                    <el-form :model="formModel" label-position="left">
                        <el-row :gutter="10">
                            <el-col :span="4">
                                <div v-for="(item, index) in complianceItems" :key="index" style="margin-bottom: 15px;">
                                    <el-form-item :label="item.label + '：'" style="margin-bottom: 5px;">
                                    </el-form-item>
                                </div>
                            </el-col>

                            <el-col :span="4">
                                <div v-for="(item, index) in complianceItems" :key="index" style="margin-bottom: 15px;">
                                    <el-form-item style="margin-bottom: 5px;">
                                        <el-radio-group v-model="item.result">
                                            <el-radio label="1" style="margin-right: 10px;">是</el-radio>
                                            <el-radio label="0">否</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div v-for="(item, index) in complianceItems" :key="index"
                                    style="margin-bottom: 15px; text-align: center;">
                                    <el-form-item label="" style="margin-bottom: 5px;">
                                        <el-button size="mini" type="primary" style="width: 120px;" @click="check(item)"
                                            :loading="getLoadingState(item.type)" :disabled="getButtonDisabled(item)">
                                            {{ getButtonText(item) }}
                                        </el-button>
                                    </el-form-item>
                                </div>
                            </el-col>

                            <el-col :span="3">
                                <div v-for="(taskKey, index) in Object.keys(aiTasks)" :key="index"
                                    style="margin-bottom: 15px; text-align: center;">
                                    <el-form-item label="" style="margin-bottom: 5px;">
                                        <span v-if="showUndeterminedPrompt(taskKey)" class="undetermined-prompt">
                                            无法判断，请人工核验！
                                        </span>
                                        <span v-else class="undetermined-prompt">
                                            &nbsp;
                                        </span>
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-card> -->

                <!-- 审核意见部分 -->
                <el-card class="detail-card">
                    <div slot="header" class="clearfix">
                        <span>审核意见</span>
                    </div>
                    <el-input type="textarea" :rows="4" v-model="reviewComment" placeholder="请输入审核意见"
                        class="review-comment-input">
                    </el-input>
                </el-card>



                <!-- 操作按钮部分 -->
                <div class="action-buttons">
                    <el-button type="success" @click="handleApprove">
                        审核通过
                    </el-button>
                    <el-button type="warning" @click="handleReject">
                        驳回修改
                    </el-button>
                </div>
            </el-tab-pane>
        </el-tabs>
        <!-- 文件预览组件 -->
        <file-preview ref="filePreview" download-base-url="/web/file/download" :custom-params="filePreviewParams" />
    </div>
</template>

<script>
import FilePreview from '@/components/FilePreview.vue';

export default {
    name: "ReviewPage",
    components: {
        FilePreview
    },
    data() {
        return {
            activeTab: 'review',
            registrationId: '',
            formData: {
                // 主体信息字段
                companyName: '',
                userId: '',
                socialCreditCode: '',
                contactsName: '',
                contactsPhone: '',

                // 资产信息字段
                platformName: '',
                assetName: '',
                dataSource: '',
                industry: '',
                dataType: '',
                region: '',
                dataScaleType: '',
                storageUnit: '',
                contactName: '',
                fieldCount: '',
                creator: '',
                updater: '',
                dataPeriod: '',
                updateCycle: '',
                rightsType: '',
                rightsPeriod: '',
                usageLimit: '',
                scenario: '',
                description: '',

                // 证明材料字段
                // reportFile: '',
                // verificationFile: '',
                // commitmentFile: '',
                // otherFile: ''
                reportFile: [],
                verificationFile: [],
                commitmentFile: [],
                otherFile: []
            },
            auditCriteria1: null,
            auditCriteria2: null,
            auditCriteria3: null,
            auditCriteria4: null,
            auditCriteria5: null,
            reviewComment: '',
            allStandardsPassed: false,
            // 文件预览组件的参数
            filePreviewParams: {},
            formModel: {
                complianceItems: []
            },
            complianceItems: [

                {
                    label: '数据来源是否合规',
                    value: '',
                    status: '未提交', // 状态：未提交、评估中、评估完毕
                    result: '',
                    type: 'source',
                    buttonMsg: '提交评估',
                    taskId: ''
                },
                {
                    label: '数据存储是否完善',
                    value: '',
                    status: '未提交',
                    result: '',
                    type: 'storage',
                    buttonMsg: '提交评估',
                    taskId: ''
                },
                {
                    label: '数据是否脱敏存储',
                    value: '',
                    status: '未提交',
                    result: '',
                    type: 'desensitization',
                    buttonMsg: '提交评估',
                    taskId: ''
                }
            ],
            aiTasks: {
                sourceTaskID: '',
                storageTaskID: '',
                desensitizationTaskID: '',
            },
            loadingStates: {
                source: false,
                storage: false,
                desensitization: false
            },
            // 添加AI评估结果状态
            aiTaskResults: {
                sourceTaskID: '',
                storageTaskID: '',
                desensitizationTaskID: '',
            },
            aiBackBaseUrl: process.env.VUE_APP_AI_BACKEND_BASE_URL,
            companyName: '',
            userId: '',
        }
    },
    created() {
        this.registrationId = this.$route.query.registrationId;
        this.loadData();
    },
    methods: {
        async loadData() {
            try {
                // 获取主体信息
                const companyInfo = await this.getRequest('/web/companyInfo/queryByRegistrationId?registrationId=' + this.registrationId,);

                // 获取资产信息
                const assetInfo = await this.getRequest('/web/dataAssets/queryForReview?registrationId=' + this.registrationId,);

                if (companyInfo && companyInfo.status === 200 && assetInfo && assetInfo.status === 200) {
                    this.formData = {
                        ...companyInfo.data,
                        ...assetInfo.data
                    };
                    // 设置公司名称和用户ID
                    this.companyName = companyInfo.data.companyName;
                    this.userId = companyInfo.data.userId;
                }
                // 设置文件预览参数
                this.setFilePreviewParams();
                // 确保文件字段是数组类型
                this.normalizeFileFields();
                console.log(this.formData);
            } catch (error) {
                console.error('加载数据失败:', error);
                this.$message.error('数据加载失败，请稍后重试');
            }
        },
        // 设置文件预览参数
        setFilePreviewParams() {
            this.filePreviewParams = {
                registrationId: this.registrationId,
                userId: this.formData.userId
            };
        },
        // 从DataComplianceManager.vue复制的方法
        getLoadingState(type) {
            return this.loadingStates[type] || false;
        },

        setLoadingState(type, isLoading) {
            this.$set(this.loadingStates, type, isLoading);
        },

        getButtonText(item) {
            if (this.getLoadingState(item.type)) {
                return '评估中';
            }

            // 根据状态显示不同的按钮文本
            if (item.status === '评估完毕') {
                return '查看详情';
            }
            return item.buttonMsg;
        },

        getButtonDisabled(item) {
            // 评估完毕后不禁用，可以查看详情
            if (item.status === '评估完毕') {
                return false;
            }

            // 其他情况根据加载状态判断
            return this.getLoadingState(item.type);
        },

        async check(item) {
            // 如果已经是评估完毕状态，则跳转到详情页
            if (item.status === '评估完毕') {
                this.toDetail(item);
                return;
            }

            // 设置加载状态
            this.setLoadingState(item.type, true);

            try {
                switch (item.type) {
                    case 'source':  // 数据来源
                        await this.handleSource();
                        break;
                    case 'storage':  // 数据存储
                        await this.handleStorage();
                        break;
                    case 'desensitization':  // 数据去敏
                        await this.handleDesensitization();
                        break;
                    default:
                        break;
                }
            } catch (error) {
                console.error('提交评估失败:', error);
                this.$message.error('提交评估失败: ' + error.message);
            } finally {
                // 无论成功失败，都清除加载状态
                this.setLoadingState(item.type, false);
            }
        },

        async handleSource() {
            try {
                // 设置状态为评估中
                const sourceItem = this.complianceItems[0];
                sourceItem.status = '评估中';

                console.log('VUE_APP_AI_BACKEND_BASE_URL:', process.env.VUE_APP_AI_BACKEND_BASE_URL);

                const response = await fetch(this.aiBackBaseUrl + 'ai/compliance/dataSource', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        company_name: this.companyName,
                        registration_id: this.registrationId,
                        user_id: this.userId
                    })
                });

                const data = await response.json();

                if (data.task_id) {
                    console.log('处理响应数据:', data);

                    // 更新任务ID和状态
                    sourceItem.taskId = data.task_id;
                    sourceItem.status = '评估完毕';

                    // 设置AI任务ID
                    this.$set(this.aiTasks, 'sourceTaskID', data.task_id);

                    if (data.ownership_judgment && data.ownership_judgment.is_owner_match) {
                        // 根据is_owner_match的值设置单选按钮
                        if (data.ownership_judgment.is_owner_match.toLowerCase() === 'yes') {
                            sourceItem.result = '1'; // 是
                        } else if (data.ownership_judgment.is_owner_match.toLowerCase() === 'no') {
                            sourceItem.result = '0'; // 否
                        }
                    }

                    this.$message.success('数据来源评估完成');
                } else {
                    console.error('响应数据为空');
                    this.$message.error(data.message || data.detail);
                    sourceItem.status = '未提交';
                }

            } catch (error) {
                console.error('API调用失败:', error);
                this.$message.error(`请求错误: ${error.message}`);
                // 恢复状态
                const sourceItem = this.complianceItems[0];
                sourceItem.status = '未提交';
            } finally {
                this.setLoadingState('source', false);
            }
        },

        async handleDesensitization() {
            console.log("开始数据脱敏核查任务：");
            try {
                // 设置状态为评估中
                const desensitizationItem = this.complianceItems[2];
                desensitizationItem.status = '评估中';

                const response = await fetch(this.aiBackBaseUrl + 'ai/datamask/dataSource', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        registration_id: this.registrationId,
                        user_id: this.userId
                    })
                });

                const data = await response.json();
                if (data.task_id) {
                    console.log('处理响应数据:', data);

                    // 更新任务ID和状态
                    desensitizationItem.taskId = data.task_id;
                    desensitizationItem.status = '评估完毕';

                    // 设置AI任务ID
                    this.$set(this.aiTasks, 'desensitizationTaskID', data.task_id);

                    if (data.datamask_judgment !== null) {
                        // 根据desensitized的值设置单选按钮
                        if (data.datamask_judgment.desensitized.toLowerCase() === 'yes') {
                            desensitizationItem.result = '1'; // 是
                        } else if (data.datamask_judgment.desensitized.toLowerCase() === 'no') {
                            desensitizationItem.result = '0'; // 否
                        }
                    }

                    this.$message.success('数据脱敏评估完成');
                } else {
                    console.error('响应数据为空');
                    this.$message.error(data.message || data.detail);
                    desensitizationItem.status = '未提交';
                }

            } catch (error) {
                console.error('API调用失败:', error);
                this.$message.error(`请求错误: ${error.message}`);
                // 恢复状态
                const desensitizationItem = this.complianceItems[2];
                desensitizationItem.status = '未提交';
            } finally {
                this.setLoadingState('desensitization', false);
            }
        },

        async handleStorage() {
            console.log("开始数据存储核查任务：");
            try {
                // 设置状态为评估中
                const storageItem = this.complianceItems[1];
                storageItem.status = '评估中';

                const response = await fetch(this.aiBackBaseUrl + 'ai/storageCompliance/dataSource', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        company_name: this.companyName,
                        registration_id: this.registrationId,
                        user_id: this.userId,
                        external_storage: false
                    })
                });

                const data = await response.json();

                if (data.task_id) {
                    console.log('处理响应数据:', data);

                    // 更新任务ID和状态
                    storageItem.taskId = data.task_id;
                    storageItem.status = '评估完毕';

                    // 设置AI任务ID
                    this.$set(this.aiTasks, 'storageTaskID', data.task_id);

                    if (data.storage_compliance_judgment !== null) {
                        // 根据compliant的值设置单选按钮
                        if (data.storage_compliance_judgment.compliant.toLowerCase() === 'yes') {
                            storageItem.result = '1'; // 是
                        } else if (data.storage_compliance_judgment.compliant.toLowerCase() === 'no') {
                            storageItem.result = '0'; // 否
                        }
                    }

                    this.$message.success('数据存储评估完成');
                } else {
                    console.error('响应数据为空');
                    this.$message.error(data.message || data.detail);
                    storageItem.status = '未提交';
                }

            } catch (error) {
                console.error('API调用失败:', error);
                this.$message.error(`请求错误: ${error.message}`);
                // 恢复状态
                const storageItem = this.complianceItems[1];
                storageItem.status = '未提交';
            } finally {
                this.setLoadingState('storage', false);
            }
        },

        toDetail(item) {
            console.log("查看详情:", item);

            if (!item.taskId || item.taskId === '') {
                this.$message.error('请先提交评估！');
                return;
            }

            console.log("TaskID:", item.taskId);

            // 构建详情页URL
            let detailUrl;
            const aiFontBaseUrl = process.env.VUE_APP_AI_FONTEND_BASE_URL
            console.log("VUE_APP_AI_FONTEND_BASE_URL:", aiFontBaseUrl);
            switch (item.type) {
                case 'source': // 数据来源
                    detailUrl = `${aiFontBaseUrl}?view=detail&task_id=${item.taskId}`;
                    break;
                case 'storage': // 数据存储
                    detailUrl = `${aiFontBaseUrl}?view=compliance-detail&task_id=${item.taskId}`;
                    break;
                case 'desensitization': // 数据脱敏
                    detailUrl = `${aiFontBaseUrl}?view=datamask-detail&task_id=${item.taskId}`;
                    break;
                default:
                    detailUrl = `${aiFontBaseUrl}?view=detail&task_id=${item.taskId}`;
            }

            // 打开新页面
            window.open(detailUrl, '_blank');
        },

        showUndeterminedPrompt(taskKey) {
            const result = this.aiTaskResults[taskKey];
            return result === 'undetermined' && this.aiTasks[taskKey];
        },
        validateAuditCriteria() {
            // 检查是否所有审核标准都已选择
            if ([this.auditCriteria1, this.auditCriteria2, this.auditCriteria3, this.auditCriteria4, this.auditCriteria5].includes(null)) {
                this.$message.error('请完成所有审核标准的选择');
                return false;
            }

            // 检查是否有标准选择"否"
            if ([this.auditCriteria1, this.auditCriteria2, this.auditCriteria3, this.auditCriteria4, this.auditCriteria5].includes(false)) {
                const failedItems = [];
                if (!this.auditCriteria1) failedItems.push('数据资产基本信息');
                if (!this.auditCriteria2) failedItems.push('数据属性信息');
                if (!this.auditCriteria3) failedItems.push('产权信息');
                if (!this.auditCriteria4) failedItems.push('描述内容相符性');
                if (!this.auditCriteria5) failedItems.push('证明材料齐全性');

                this.$message.error(`以下审核标准选择"否"，不能审核通过: ${failedItems.join('、')}`);
                return false;
            }

            return true;
        },

        handleApprove() {
            // 验证审核标准
            if (!this.validateAuditCriteria()) {
                return;
            }

            this.$confirm('确认审核通过该数据资产?', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning'
            }).then(() => {
                this.$axios.post('/web/dataAssets/approve/pass', {
                    registrationId: this.registrationId,
                    auditCriteria1: this.auditCriteria1,
                    auditCriteria2: this.auditCriteria2,
                    auditCriteria3: this.auditCriteria3,
                    auditCriteria4: this.auditCriteria4,
                    auditCriteria5: this.auditCriteria5,
                    reviewComment: this.reviewComment
                }).then(resp => {
                    if (resp && resp.status === 200) {
                        this.$message.success('审核通过成功');
                        this.$router.go(-1);
                    }
                });
            });
        },

        handleReject() {
            // 检查是否填写了审核意见
            if (!this.reviewComment || this.reviewComment.trim() === '') {
                this.$message.error('驳回修改必须填写审核意见');
                return;
            }

            this.$confirm('确认驳回该数据资产?', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning'
            }).then(() => {
                this.$axios.post('/web/dataAssets/approve/rejected', {
                    registrationId: this.registrationId,
                    auditCriteria1: this.auditCriteria1,
                    auditCriteria2: this.auditCriteria2,
                    auditCriteria3: this.auditCriteria3,
                    auditCriteria4: this.auditCriteria4,
                    auditCriteria5: this.auditCriteria5,
                    reviewComment: this.reviewComment
                }).then(resp => {
                    if (resp && resp.status === 200) {
                        this.$message.success('驳回成功');
                        this.$router.go(-1);
                    }
                });
            });
        },
        handleDetail() {
            this.$router.push({
                path: '/index/company/review-manage',
                query: {
                    registrationId: this.registrationId,
                    formData: JSON.stringify(this.formData)
                }
            });
        },
        async downloadFile(filename) {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/file/download/' + filename,
                    params: {
                        registrationId: this.registrationId,
                        userId: this.formData.userId
                    },
                    responseType: 'blob'
                });

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }
        },

        viewCertificateDetail() {
            if (this.formData.certificateFile) {
                this.$router.push({
                    path: '/company/certificate-detail',
                    query: {
                        registrationId: this.registrationId,
                        certificateFile: this.formData.certificateFile
                    }
                });
            } else {
                this.$message.warning('证书文件不存在');
            }
        },
        // 判断文件是否可以预览
        isPreviewable(fileName) {
            if (!fileName) return false;

            // 确保fileName是字符串
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) return false;

            const ext = this.getFileExtension(fileNameStr);
            const previewableTypes = [
                'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', // 图片
                'pdf', // PDF
                'xls', 'xlsx', 'csv', // Excel文件
                'doc', 'docx', // Word文档
                'txt', 'json', 'xml', 'csv', 'log', 'js', 'css', 'html', 'md' // 文本文件
            ];
            return previewableTypes.includes(ext);
        },
        // 预览文件
        async previewFile(fileName) {
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) {
                this.$message.warning('文件名不能为空');
                return;
            }

            this.isPreviewLoading = true;
            try {
                await this.$refs.filePreview.openPreview(
                    { fileName: fileNameStr },
                    this.registrationId
                );
            } catch (error) {
                console.error('预览失败:', error);
                this.$message.error('文件预览失败: ' + (error.message || ''));
            } finally {
                this.isPreviewLoading = false;
            }
        },


        // 获取文件扩展名
        getFileExtension(filename) {
            if (!filename) return '';
            const parts = String(filename).split('.');
            return parts.length > 1 ? parts.pop().toLowerCase() : '';
        },

        // 标准化文件字段为数组
        normalizeFileFields() {
            const fileFields = ['reportFile', 'verificationFile', 'commitmentFile', 'otherFile'];

            fileFields.forEach(field => {
                const value = this.formData[field];

                if (value) {
                    if (typeof value === 'string') {
                        // 如果是字符串，尝试按逗号分割
                        let files = value.split(',')
                            .map(file => file.trim())
                            .filter(file => file.length > 0);
                        this.formData[field] = files;
                    } else if (Array.isArray(value)) {
                        // 已经是数组，直接使用
                        this.formData[field] = value;
                    } else {
                        // 其他类型，转换为数组
                        this.formData[field] = [value];
                    }
                } else {
                    // 如果字段为空，设置为空数组
                    this.formData[field] = [];
                }
            });
        },
    },
}

</script>

<style scoped>
.review-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: calc(100vh - 40px);
}

.detail-card {
    margin-bottom: 20px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    overflow: visible;
}

.detail-card>>>.el-card__header {
    background-color: #e2e4e7;
    color: rgb(1, 1, 1);
    font-size: 16px;
    font-weight: 100;
    width: 100%px;
    height: 40px;
    border-radius: 8px 8px 0 0;
}


.detail-card>>>.el-descriptions__title {
    font-size: 14px;
    color: #606266;
}

.detail-card>>>.el-descriptions-item__label {
    font-size: var(--label-font-size, 18px);
    color: var(--label-color, #000000);
    background-color: var(--label-color, #fcfcfc);
    width: var(--label-width, 100px);

}

.detail-card>>>.el-descriptions-item__content {
    font-size: var(--label-font-size, 16px);
    color: var(--label-color, #6b6b6b);
    background-color: var(--label-color, #ffffff);
    width: var(--label-width, 400px);
}

/* 自定义样式示例 */
.custom-label {
    --label-font-size: 16px;
    --label-color: #333;
    --label-bg-color: #f0f0f0;
    --label-min-width: 150px;
    --label-width: 25%;
    --label-padding: 8px 20px 8px 10px;
}

.custom-content {
    --content-font-size: 15px;
    --content-color: #444;
    --content-bg-color: #f8f8f8;
    --content-min-width: 250px;
    --content-width: 75%;
    --content-padding: 8px;
}

.el-form-item__label {
    font-size: 14px;
    color: #606266;
}

.el-button {
    font-size: 14px;
    padding: 10px 20px;
}

.el-textarea__inner {
    font-size: 14px;
    color: #303133;
}

.review-standards {
    display: flex;
    flex-direction: column;
}

.standard-item {
    margin-bottom: 50px;
}

.standard-item>>>.el-checkbox__inner {
    border-color: #409EFF;
}

.standard-item.is-checked>>>.el-checkbox__inner {
    background-color: #409EFF;
    border-color: #409EFF;
}

.required-field::before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}

.review-standard-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #ebeef5;
}

.review-standard-item:last-child {
    border-bottom: none;
}

.review-comment-input {
    width: 100%;
}

.action-buttons {
    margin-top: 20px;
    text-align: center;
}

.undetermined-prompt {
    color: #f56c6c;
    font-size: 12px;
    display: inline;
}
</style>